import { render, staticRenderFns } from "./SpotPricingLogs.vue?vue&type=template&id=48152727&scoped=true"
import script from "./SpotPricingLogs.vue?vue&type=script&lang=js"
export * from "./SpotPricingLogs.vue?vue&type=script&lang=js"
import style0 from "./SpotPricingLogs.vue?vue&type=style&index=0&id=48152727&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48152727",
  null
  
)

export default component.exports